/**
 * Reconciliation Tab Component
 * 
 * Wrapper component for ReconciliationDashboard in embedded mode.
 * Features:
 * - View instrument reconciliation status
 * - Compare data across different sources
 * - Identify and resolve data discrepancies
 * 
 * @module InstrumentMaster/tabs/ReconciliationTab
 */

import React from 'react';
import ReconciliationDashboard from '../Reconciliation/ReconciliationDashboard';

const ReconciliationTab = () => {
  return <ReconciliationDashboard isEmbedded={true} />;
};

export default ReconciliationTab;
